import { formatMonthYear } from './format';

/** Date-keyed rows convertible to line-chart categories + series. */
export type HFDateSeriesRow = {
  date: string | Date;
  [series: string]: number | string | Date;
};

export type HFDateSeriesLine = {
  categories: string[];
  series: Array<{ name: string; data: number[] }>;
};

function seriesKeys(row: HFDateSeriesRow | undefined): string[] {
  if (!row) return [];
  return Object.keys(row).filter((key) => key !== 'date');
}

/** Convert date-keyed rows into line-chart `categories` + `series`. */
export function dateRowsToLineChart(rows: HFDateSeriesRow[], names = seriesKeys(rows[0])): HFDateSeriesLine {
  return {
    categories: rows.map((row) => formatMonthYear(String(row.date))),
    series: names.map((name) => ({
      name,
      data: rows.map((row) => {
        const n = typeof row[name] === 'number' ? row[name] : Number(row[name]);
        return Number.isFinite(n) ? n : 0;
      }),
    })),
  };
}
